export function makeNumberOrUndefined(input) { if (input === null || input === undefined) {
    return undefined;
} return Number(input); }
